export default __webpack_public_path__ + "static/media/img-0686-bosnia-premium-face.55362ace.png";